import styled from 'styled-components';

interface IWrapperProps {
  isDisabled: boolean;
  hasError?: boolean;
}

export const SWrapper = styled.div<IWrapperProps>`
  display: flex;
  align-items: center;
  filter: ${({ isDisabled }) => (isDisabled ? 'opacity(0.5)' : 'unset')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
`;

interface ICheckbox {
  isChecked: boolean;
  hasError?: boolean;
}

export const SCheckbox = styled.div<ICheckbox>`
  align-items: center;
  border-radius: 1.25px;
  border: 1px solid ${({ theme }) => theme.colors.primaryText};
  color: ${({ theme, isChecked, hasError }) => {
    if (isChecked) {
      return hasError ? 'white' : theme.colors.primaryText;
    } else return 'transparent';
  }};
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  ${({ hasError, theme, isChecked }) =>
    isChecked
      ? `border: none; background-color: ${hasError ? theme.colors.error : theme.colors.primary}`
      : 'color: transparent'};
`;

export const SLabel = styled.div<ICheckbox>`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12.5px;
  letter-spacing: 0;
  margin-left: 10px;
  position: relative;
  white-space: nowrap;
`;
